import { render, staticRenderFns } from "./DistributionRankPage.vue?vue&type=template&id=6b90d631&scoped=true"
import script from "./DistributionRankPage.vue?vue&type=script&lang=js"
export * from "./DistributionRankPage.vue?vue&type=script&lang=js"
import style0 from "./DistributionRankPage.vue?vue&type=style&index=0&id=6b90d631&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b90d631",
  null
  
)

export default component.exports